import React from 'react';
import FieldManagementFormProto from "../../../../proto/render/management/management-form";


// @ts-ignore
import FormRow from "src/core/gd-form/form/form-ui5/form-row";
// @ts-ignore
import FormSelect from "src/core/gd-form/form-element/select-new/select-new";
import {FieldManagementFormProps} from "../../../../render/management-form";
import FormManager from "../../../../../gd-form/common/form-manager";
import DecimalPlacesSelector from "../../../number/components/management-form/decimal-places";
import FormError from "../../../../../gd-form/common/form-error/form-error";
import FormToggle from "../../../../../gd-form/form-element/toggle-new/toggle"

export default class FieldCurrency_ManagementForm extends FieldManagementFormProto {

    constructor(props:FieldManagementFormProps) {
        super(props);

        this.initFormData.symbolId          = 'us_dollar'
        this.initFormData.decimalPlaces     = 0
        this.initFormData.positiveOnly      = false
        this.initFormData.integersOnly      = false

        if (this.props.field) {
            this.initFormData.symbolId      = _.get(this.props,'field.symbolId', 'us_dollar')
            this.initFormData.decimalPlaces = _.get(this.props,'field.decimalPlaces', 0)
            this.initFormData.positiveOnly  = _.get(this.props,'field.positiveOnly', false)
            this.initFormData.integersOnly  = _.get(this.props,'field.integersOnly', false)
        }

        this.state = {
            noDecimalPlaces: this.initFormData.integersOnly
        }

        this.formStructure.fields.symbolId = {
            type: 'select',
            isRequired: true,
            label: 'Symbol'
        }

        this.formStructure.fields.decimalPlaces = {
            type: 'select',
            isRequired: true,
            label: 'Decimal places'
        }

        this.formStructure.fields.positiveOnly = {
            type: 'select',
            isRequired: true,
            label: 'Positive only'
        }

        this.formStructure.fields.integersOnly = {
            type: 'select',
            isRequired: true,
            label: 'Integers only',
            onUserChange: () => {
                // hide decimal places and set no 0 if integersOnly is true
                this.form?.setValue('decimalPlaces', 0)
                this.setState({noDecimalPlaces: this.form?.getValue('integersOnly')})
            }
        }

        // important to have it here !
        this.formStructure.onSubmit = this.onSubmit;

        this.form = new FormManager(this.formStructure, this.initFormData);
    }

    onSubmit = (result:any) => {
        super.onSubmit(result);

        this.props.field.symbolId       = result.symbolId
        this.props.field.decimalPlaces  = result.decimalPlaces
        this.props.field.positiveOnly   = result.positiveOnly
        this.props.field.integersOnly   = result.integersOnly

        // props.field is an object so we never return anything in here
        this.props.onSubmit(this.props.field);
    }

    getSymbolOptions = () => {
        const res = [];
        for (let prop in gd.const.currency){
            const { label, value } = gd.const.currency[prop];
            res.push({label: label, value:value});
        }
        return res;
    }

    renderAdditionalControls() {
        return (
            <>
                <FormRow label="Symbol">
                    <FormSelect form={this.form} name="symbolId" options={this.getSymbolOptions()}/>
                    <FormError form={this.form} name="symbolId"/>
                </FormRow>

                <FormRow label="Positive only">
                    <FormToggle size="20" form={this.form} name="positiveOnly" />
                    <FormError form={this.form} name="positiveOnly"/>
                </FormRow>

                <FormRow label="Integers only">
                    <FormToggle size="20" form={this.form} name="integersOnly" />
                    <FormError form={this.form} name="integersOnly"/>
                </FormRow>

                {!this.state.noDecimalPlaces &&
                    <FormRow label="Decimal places">
                        <DecimalPlacesSelector form={this.form} name="decimalPlaces" minValue={0} maxValue={9}/>
                        <FormError form={this.form} name="decimalPlaces"/>
                    </FormRow>}
            </>
        )
    }

}
